export default (initialState, handlers) =>
  (state = initialState, action) => {
    return Object.prototype.hasOwnProperty.call(handlers, action.type)
      ? handlers[action.type](state, action)
      : state;
  };
